<template>
  <div class="datatable">
    <table class="table">
      <caption v-if="caption">{{ caption }}</caption>
      <thead>
        <th v-if="hasActions">Actions</th>
        <th v-for="column in columns" :key="column.name">{{ column.name }}</th>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="getRowKey(row)">
          <td v-if="hasActions" :key="getRowKey(row) + '_action'">
            <DataTableAction
              v-for="action in actions"
              :key="getRowKey(row) + '_action_' + action.name"
              :row="row"
              :action="action"
            />
          </td>
          <td
            v-for="column in columns"
            :key="getRowKey(row) + '_' + column.name"
          >
            <DataCell :type="column.type" :value="row[column.name]" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DataCell from '@/components/DataCell.vue'
import DataTableAction from '@/components/DataTableAction.vue'

export default {
  name: 'DataTable',
  props: {
    caption: String,
    rowKeys: Array,
    actions: Array,
    columns: Array,
    rows: Array
  },
  computed: {
    hasActions: function() {
      return this.actions && this.actions.length
    }
  },
  methods: {
    getRowKey(row) {
      return this.rowKeys.map(keyName => row[keyName]).join('_')
    }
  },
  components: {
    DataCell,
    DataTableAction
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-spacing: 0;
}
th {
  text-align: left;
}
th,
td {
  border-bottom: 1px solid var(--td-border-color);
}
tr:hover {
  background-color: var(--tr-hover-color);
}
caption {
  text-align: left;
  font-weight: bold;
}
</style>
